
import { v4 as uuidv4 } from "uuid";
import { AbilityScoreExpandedType } from "@dndModels/Types";

/**
 * This is a simple increasing of an Ability Score.
 * It has an amount and options.  
 * If the options only has one in it, then it automatically uses it.
 */
export class ASIFeature {
  true_id = "";
  // id: number = -1;
  amount = 1;
  options: AbilityScoreExpandedType[] = [];
  selectable_key = "";

  constructor(obj?: any) {
    this.true_id = obj && obj.true_id && obj.true_id.length > 0 ? obj.true_id : uuidv4().toString();
    if (obj) {
      // this.id = obj.id !== undefined ? obj.id : -1;
      this.amount = obj.amount !== undefined ? obj.amount : 1;
      this.options = obj.options ? [...obj.options] : [];
      this.selectable_key = obj.selectable_key ? obj.selectable_key : "";
    }
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      amount: this.amount,
      options: [...this.options],
      selectable_key: this.selectable_key
    };
  }

  copy(copyMe: ASIFeature, drop_ids = false): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
      // this.id = copyMe.id;
    }
    this.amount = copyMe.amount;
    this.options = [...copyMe.options];
    this.selectable_key = copyMe.selectable_key;
  }

  clone(drop_ids = false): ASIFeature {
    const new_obj = new ASIFeature();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}